import * as FileEntry           from '../util/file_entry';
import * as UI                  from '../ui';
import { DropZone }             from './drop_zone';
import { UnsupportedFileError } from './drop_zone';
import F7Event                  from '../app/events/f7_event';
import React                    from 'react';
import store                    from '../store';

const extensionsAllowed = [ 'png', 'jpg', 'jpeg' ];

export default function UploadImage({ onSuccess, onError }) {
  async function onFile(file) {
    if (file) {
      try {
        const mimeType      = await FileEntry.getMimeTypeFromFileEntry(file);
        const blob          = await FileEntry.getBlobFromFileEntry(file, mimeType);
        const { nativeURL } = file;
        onSuccess({ blob, mimeType, nativeURL });
      } catch (error) {
        onError(new UnsupportedFileError(file));
      }
    }
  }

  async function getImage(options) {
    try {
      const { camera } = window.navigator;
      const uri        = await new Promise(function(resolve, reject) {
        camera.getPicture(resolve, reject, options);
      });

      const fileEntry = await new Promise(function(resolve, reject) {
        window.resolveLocalFileSystemURL(uri, resolve, reject);
      });

      onFile(fileEntry);
    } catch (error) {
      const androidCancelled = (error === 'No Image Selected');
      const iOSCancelled     = (error === 'has no access to assets');
      const cancelled        = (iOSCancelled || androidCancelled);

      if (!cancelled)
        store.dispatch(UI.toast('An error occurred. Please check that the app has permission to access the photo gallery.'));
    }
  }

  function openActionSheet({ target }) {
    target.dispatchEvent(new F7Event(app => {
      const { camera }  = window.navigator;
      const actionSheet = app.actions.create({
        buttons: [
          {
            text: 'Choose from Library',
            onClick() {
              const sourceType = camera.PictureSourceType.PHOTOLIBRARY;
              getImage({ sourceType });
            }
          },
          {
            text: 'Take Photo',
            onClick() {
              const sourceType = camera.PictureSourceType.CAMERA;
              getImage({ sourceType });
            }
          },
          {
            text:  'Cancel',
            color: 'red'
          }
        ]
      });

      actionSheet.open();
    }));
  }

  const isCordova = window.navigator.camera;

  return (
    <form>
      <DropZone onFile={onFile} onError={onError} extensionsAllowed={extensionsAllowed}>
        {isCordova && (
          <label onClick={openActionSheet}>
            <div className="upload-file__dropzone__button button">Pick a photo</div>
          </label>
        )}
        {!isCordova && (
          <label className="upload-file__dropzone__label" htmlFor="upload-file">
            Drag and drop image file here <br/>
            <span className="upload-file__dropzone__or">or </span><br/>
            <span className="upload-file__dropzone__button button">Choose a file</span>
          </label>
        )}
      </DropZone>
    </form>
  );
}

